import classNames from 'classnames';
import React, { FC, useState } from 'react';
import { Hyperlink } from '../../../components/Hyperlink';
import { VerifyLawyerModal } from '../../../lawyer/verify-lawyer-modal/VerifyLawyerModal';
import { UserContextType } from '../../../user/user.types';
import { RestrictedModal } from '../../../components/modal/components/modal-restricted/RestrictedModal';
import { WithModalProps } from '../../../components/modal/withModal';
import styles from './report_error_modal_line.module.scss';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = {
  border?: boolean;
  title: JSX.Element;
  subtitle: JSX.Element;
  url: string;
  loggedIn: UserContextType['loggedIn'];
  verified: boolean;
  lawyerName: string;
  lawyerId: string;
  openModal: WithModalProps['openModal'];
  closeParentModal: () => void;
};

export const ReportErrorModalLine: FC<Props> = ({
  loggedIn,
  openModal,
  verified,
  url,
  lawyerName,
  lawyerId,
  closeParentModal,
  border = false,
  title,
  subtitle,
}) => {
  const [hovered, setHovered] = useState(false);

  const linkParams = () => {
    if (!loggedIn) {
      return {
        onClick: () => {
          closeParentModal();
          openModal((modalProps) => (
            <RestrictedModal
              title="Modifiez votre page pour gagner en visibilité"
              source="expertise_report_error"
              {...modalProps}
            />
          ));
        },
      };
    }
    if (verified) {
      return {
        href: url,
      };
    }
    return {
      onClick: () => {
        closeParentModal();
        openModal((modalProps) => (
          <VerifyLawyerModal
            lawyerName={lawyerName}
            lawyerId={lawyerId}
            {...modalProps}
          />
        ));
      },
    };
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Hyperlink
        className={classNames(styles.link, { [styles.border]: border })}
        {...linkParams()}
      >
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
        {hovered && (
          <MaterialIcon name="arrow_forward" className={styles.arrow} />
        )}
      </Hyperlink>
    </div>
  );
};
